"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullSupportedFormulaEngines = exports.FullSupportedFormulaEnginesIterable = exports.SupportedFormulaEngines = exports.SupportedFormulaEnginesIterable = void 0;
// TODO: deprecate below engine once each formula-driven attribute has been
// migrated over to below "FullSupportedFormulaEngines"
exports.SupportedFormulaEnginesIterable = ['hyperFormula1'];
exports.SupportedFormulaEngines = {
    HyperFormula1: 'hyperFormula1',
};
// Since not rolling out ExcelEngine to all potential candidates, creating separate
// type to help alleviate migration efforts by supporting both flows
exports.FullSupportedFormulaEnginesIterable = [
    'hyperFormula1',
    'excelEngine1',
];
exports.FullSupportedFormulaEngines = {
    HyperFormula1: 'hyperFormula1',
    ExcelEngine1: 'excelEngine1',
};
//# sourceMappingURL=FormulaEngine.js.map